<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="width:100%;">
        <div class="d-flex justify-center ">
            <div class="multiple-image-input grey lighten-2 d-flex justify-center align-center">
                <v-btn
                        icon
                        color="orange lighten-2"
                        @click="inputClick"
                        x-large
                >
                    <v-icon>add_circle</v-icon>
                </v-btn>
            </div>
        </div>
        <v-file-input
                clearable
                v-model="images"
                :ref="inputRef"
                chips
                multiple
                @change="valueChange"
                color="orange lighten-2"
        >
            <template v-slot:selection="data">
                <v-chip
                        :input-value="data.text"
                        close
                        color="grey"
                        outlined
                        @click:close="remove(data.index)"
                >{{ data.text }}</v-chip>
            </template>
        </v-file-input>
    </div>

</template>

<script>
    export default {
        name: "MultipleImageInput",
        data() {
            return {
                images: [],
                inputRef: 'imagesInput',
                itemsRegionSelect: null,
            }
        },
        methods: {
            inputClick() {
                const targetInput = this.$refs[this.inputRef].$el.querySelector('input[type="file"]');

                if(targetInput) {
                    targetInput.click();
                }

            },
            valueChange() {
                this.$emit('value-change', this.images);
            },

            remove(idx) {
                return this.images.splice(idx,1);
            },
        },
    }
</script>

<style scoped>
    .multiple-image-input {
        width: 150px;
        height: 150px;
    }
</style>
